import { render, staticRenderFns } from "./CommingSoon.vue?vue&type=template&id=072750d4&scoped=true&"
import script from "./CommingSoon.vue?vue&type=script&lang=js&"
export * from "./CommingSoon.vue?vue&type=script&lang=js&"
import style0 from "./CommingSoon.vue?vue&type=style&index=0&id=072750d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072750d4",
  null
  
)

component.options.__file = "CommingSoon.vue"
export default component.exports